/**
 * Session boundary states — shown while the tokenized link is resolving or if it fails to load.
 * These render before the context exists (so no full AppShell header), on the same warm paper.
 * "Never a dead spinner": the loading state is a gentle brand pulse, not a spinner.
 */
import { ThreadMark } from './ThreadMark';
import { Button } from './ui/button';

function CenteredPaper({ children }: { children: React.ReactNode }) {
  return (
    <div className="referee-shell flex min-h-svh flex-col items-center justify-center px-6 text-center">
      {children}
    </div>
  );
}

export function SessionLoading() {
  return (
    <CenteredPaper>
      {/* "Never a dead spinner": a gentle brand pulse (CSS; stilled under reduced motion). */}
      <div className="brand-pulse">
        <ThreadMark className="h-6 w-auto" />
      </div>
      <p className="mt-4 font-display text-[13px] font-medium text-ink-quiet" role="status">
        Opening your link…
      </p>
    </CenteredPaper>
  );
}

export function SessionError({ onRetry }: { onRetry: () => void }) {
  return (
    <CenteredPaper>
      <ThreadMark className="h-6 w-auto" />
      <h1 className="mt-5 font-display text-[22px] font-semibold tracking-[-0.02em] text-ink">
        We couldn&rsquo;t open this link
      </h1>
      <p className="mt-2 max-w-[30ch] font-body text-[13px] leading-relaxed text-ink-70">
        Something went wrong on our side. Please try again in a moment.
      </p>
      <div className="mt-6">
        <Button variant="coral" onClick={onRetry}>
          Try again
        </Button>
      </div>
    </CenteredPaper>
  );
}
